import { render, staticRenderFns } from "./NavList.vue?vue&type=template&id=4b957054&scoped=true&"
import script from "./NavList.vue?vue&type=script&lang=ts&"
export * from "./NavList.vue?vue&type=script&lang=ts&"
import style0 from "./NavList.vue?vue&type=style&index=0&id=4b957054&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b957054",
  null
  
)

export default component.exports